import { render, staticRenderFns } from "./QuestionRow.vue?vue&type=template&id=dcc6802e&scoped=true"
import script from "./QuestionRow.vue?vue&type=script&lang=js"
export * from "./QuestionRow.vue?vue&type=script&lang=js"
import style0 from "./QuestionRow.vue?vue&type=style&index=0&id=dcc6802e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcc6802e",
  null
  
)

export default component.exports